export const formatNumber = (number) => {
  if (isNaN(number)) return "--";
  return new Intl.NumberFormat().format(number);
};

export const formatChange = (change) => `${change > 0 ? "+" : ""}${change}%`;

export const formatDate = (date) => {
  let d = new Date(date),
    month = d.toLocaleString("default", { month: "short" }),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${month} ${day}, ${year}`;
};

export const formatFilesize = (bytes) => {
  const thresh = 1000;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let u = -1;
  const r = 10 ** 2;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(2) + " " + units[u];
};

export const formatChangeStyle = (el, change) => {
  change > 0
    ? el.classList.add(...["sh-pill-up", "sh-pill-red"])
    : el.classList.add(...["sh-pill-down", "sh-pill-green"]);
};
